import React from "react";

// TP-Friendlies WEEK/DATE STRIP — the one genuinely net-new browse component
// (DECISIONS D-004.3; nothing like it existed in the codebase). A horizontal,
// scrollable row of date buckets that doubles as a filter, with per-bucket counts.
//
// Buckets come verbatim from the feed's `meta.buckets` (D-007.5): a per-DAY count
// for the next 14 days, then a per-MONTH bucket for everything later. This
// component never computes counts — it renders the server aggregate and reports
// the picked bucket up; the page maps it to a { date_from, date_to } filter.
//
// A leading "All dates · soonest first" chip clears the date filter. Active chip =
// solid blue with a translucent count badge; inactive = white with a bordered
// grey badge (design tokens §4.3).
const Chip = ({ active, label, sublabel, count, onClick, dim }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex flex-col items-start flex-shrink-0 rounded-[10px] border px-3 py-1.5 text-left transition-colors ${
      active
        ? "bg-[#2283FF] border-[#2283FF] text-white"
        : "bg-white border-[#E0E6EE] text-[#33475E] hover:border-[#B5CCF0]"
    } ${dim && !active ? "opacity-60" : ""}`}
    aria-pressed={active}
  >
    <span className="flex items-center gap-1.5">
      <span className="text-[12.5px] font-semibold whitespace-nowrap">{label}</span>
      <span
        className={`inline-flex items-center justify-center min-w-[18px] h-[16px] rounded-full px-1 text-[10.5px] font-bold ${
          active ? "text-white" : "text-[#66707F]"
        }`}
        style={{ backgroundColor: active ? "rgba(255,255,255,.22)" : "#F0F3F7" }}
      >
        {count}
      </span>
    </span>
    {sublabel && (
      <span className={`text-[10.5px] ${active ? "text-white/80" : "text-[#98A2B3]"}`}>{sublabel}</span>
    )}
  </button>
);

const WeekStrip = ({ buckets = [], activeKey = "all", onSelect, totalCount = 0 }) => {
  return (
    <div
      className="flex flex-nowrap items-stretch gap-2 overflow-x-auto pb-1 -mx-4 px-4 sm:mx-0 sm:px-0"
      role="group"
      aria-label="Filter by date"
      data-testid="friendly-week-strip"
    >
      <Chip
        active={activeKey === "all"}
        label="All dates"
        sublabel="soonest first"
        count={totalCount}
        onClick={() => onSelect && onSelect({ key: "all" })}
      />
      {buckets.map((b) => (
        <Chip
          key={b.key}
          active={activeKey === b.key}
          label={b.label}
          count={b.count}
          dim={b.count === 0}
          onClick={() => onSelect && onSelect(b)}
        />
      ))}
    </div>
  );
};

export default WeekStrip;
